import React, { useState } from "react";

export const RequestItem = ({ data, methods, models }) => {
  const [isOpenBrand, setIsOpenBrand] = useState(false);
  const [isOpenModel, setIsOpenModel] = useState(false);
  const [selectedOptionBrand, setSelectedOptionBrand] = useState("");
  const [selectedOptionModel, setSelectedOptionModel] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const toggleDropdownBrand = () => {
    setIsOpenBrand(!isOpenBrand);
  };

  const toggleDropdownModel = () => {
    setIsOpenModel(!isOpenModel);
  };

  const selectOptionBrand = (option) => {
    setSelectedOptionBrand(option.name);
    setIsOpenBrand(false);
  };

  const selectOptionModel = (option) => {
    setSelectedOptionModel(option.name);
    setIsOpenModel(false);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredBrands = data?.filter((option) =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredModels = models?.filter((option) =>
    option?.name.toLowerCase().includes(searchTerm.toLowerCase())
  );


  return (
    <div className="requestItem">
      <h4>ثبت درخواست کالا و قطعه</h4>
      <div className="requestItemFilters">
        <span>خودرو خود را انتخاب کنید</span>
        <div className="requestCustomSelect">
          <div className="requestSelectHeader" onClick={toggleDropdownBrand}>
            <span>{selectedOptionBrand || "برند"}</span>
            <i className="icon-chevron-down" />
          </div>
          {isOpenBrand && (
            <div className="requestDropdownBox">
              <div className="requestDropdownContent">
                <input
                  type="text"
                  placeholder="جستوجو"
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <ul className="requestOptions">
                  <li
                    onClick={() => {
                      selectOptionBrand("");
                      methods.selectBrand("");
                      selectOptionModel("");
                      methods.selectModel("");
                    }}
                  >
                    هیچکدام
                  </li>
                  {filteredBrands.map((option, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        selectOptionBrand(option);
                        methods.selectBrand(option.id);
                      }}
                    >
                      {option.name}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
        <div className="requestCustomSelect">
          <div className="requestSelectHeader" onClick={toggleDropdownModel}>
            <span>{selectedOptionModel || "نام خودرو"}</span>
            <i className="icon-chevron-down" />
          </div>
          {isOpenModel && (
            <div className="requestDropdownBox">
              <div className="requestDropdownContent">
                <input
                  type="text"
                  placeholder="جستوجو"
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <ul className="requestOptions">
                  <li
                    onClick={() => {
                      selectOptionModel("");
                      methods.selectModel("");
                    }}
                  >
                    هیچکدام
                  </li>
                  {filteredModels?.map((option, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        selectOptionModel(option);
                        methods.selectModel(option.id);
                      }}
                    >
                      {option.name}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
      <input
        type="text"
        placeholder="مدل و تیپ خودرو خود را بنویسید"
        onChange={(e) => methods.handleCarCategoryTitle(e.target.value)}
      />
      <input
        type="text"
        placeholder="نام قطعه و توضیحات"
        onChange={(e) => methods.handleDescription(e.target.value)}
      />
      <div className="submitRequest" onClick={() => methods.submitRequest()}>
        ثبت درخواست
      </div>
    </div>
  );
};
